import { fetchGroupPrice } from '@gn-audio/core/api/pricing/fetch-group-price';
import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { AvailabilityState } from '@gn-audio/core/common/enums';
import { Component, Input, OnInit } from 'angular-ts-decorators';
import { TranslationKey } from 'src/Foundation/Translation/platform';

import template from './product-state-label.component.html';

@Component({
  selector: 'productStateLabel',
  template,
})
export class ProductStateLabelComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input('<pId') public productId?: number;

  private availabilityState?: number;

  constructor(private $q: ng.IQService) { }

  public ngOnInit() {
    this.$q.when(fetchGroupPrice(this.productId))
      .then((price?: IFromPrice | ISFCCGroupPrice) => {
        this.availabilityState = price ? price.availabilityState : AvailabilityState.WhereToBuy;
      });
  }

  public get showLabel(): boolean {
    return this.availabilityState >= AvailabilityState.Add && this.availabilityState !== AvailabilityState.WhereToBuy;
  }

  public get availabilityStateCssClass(): string {
    return `state-${this.availabilityState}`;
  }

  public get availabilityStateDictionaryKey(): string {
    switch (this.availabilityState) {
      case AvailabilityState.Add:
      case AvailabilityState.PreOrder:
        return TranslationKey.NewLabel;

      case AvailabilityState.BackOrder:
      case AvailabilityState.ComingSoon:
        return TranslationKey.ComingSoonLabel;

      default:
        return '';
    }
  }
}
